import { render, staticRenderFns } from "./downloadFun.vue?vue&type=template&id=63a8bed2"
import script from "./downloadFun.vue?vue&type=script&lang=js"
export * from "./downloadFun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports